import { useEffect } from 'react';

import { isApplicationModeInfinity } from 'src/data/system';
import {
  useCurrentCustomerId,
  useCurrentUser,
  useCurrentWorkspaceId,
  usePerformanceActions,
} from 'src/store';

/**
 * This hook is used to maintain the performance store state.
 */
export const useMaintainPerformanceStoreState = () => {
  useMaintainCommonStoreState();
};

const useMaintainCommonStoreState = () => {
  const currentUser = useCurrentUser();
  const currentCustomerId = useCurrentCustomerId();
  const currentWorkspaceId = useCurrentWorkspaceId();
  const performanceActions = usePerformanceActions();

  useEffect(() => {
    if (!currentWorkspaceId) {
      return;
    }

    performanceActions.queryWorkspaceAccounts(currentWorkspaceId);

    return () => {
      performanceActions.cancelWaitRequests();
    };
  }, [performanceActions, currentWorkspaceId]);

  const confirmedUserId = currentUser?.isConfirmed ? currentUser.id : null;
  useEffect(() => {
    if (!confirmedUserId || !currentCustomerId) {
      return;
    }

    // we don't need user's "integration assets" in Infinity
    if (isApplicationModeInfinity()) {
      return;
    }

    performanceActions.queryChannelsAuthState();
    performanceActions.queryUserIntegrationAccounts(confirmedUserId);

    return () => {
      performanceActions.cancelWaitRequests();
      performanceActions.clearStore();
    };
  }, [performanceActions, confirmedUserId, currentCustomerId]);
};
